/**
 * @author Harshitha.k
 * @description 
 */

import axios from 'axios';
import { connect } from 'react-redux';
import { constant } from './constants';
import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { getHMICalls } from '../hmicalls';
import Editor from '@monaco-editor/react';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { API_MASTERCONFIGURATION, API_HMI } from '../../../commons/api';
import {
  Drawer,
  Input,
  Form,
  Row,
  Col,
  Select,
  message,
  Collapse,
  Upload,
  Button,
  Tabs,
  Modal,
  Space
} from 'antd';
import {
  PlusOutlined,
  CaretRightOutlined,
  SearchOutlined,
  UploadOutlined,
  MinusCircleOutlined
} from '@ant-design/icons';

const { Option } = Select;
const { TabPane } = Tabs;

const HmiConfiguration = (props) => {
  const UserDetails = props.UserDetails;
  const [visible, setVisible] = useState(false);
  // const [theme, setTheme] = useState('vs-dark');
  const [searchText, setSearchText] = useState('');
  const [editObj, setEditObj] = useState({});
  const [recordData, setRecordData] = useState({});
  const [datasource, setDatasource] = useState([]);
  const [userId, setUserId] = useState(props.userDeatils);
  const [userProfile, setUserProfile] = useState(props.userProfile);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [editEditor, setEditEditor] = useState({});
  const [imageDetails, setImageDetails] = useState({});
  const [imageUrl, setImageUrl] = useState('');
  const [imagebaseUrl, setImagebaseUrl] = useState('');
  const [defaultFileList, setDefaultFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeDetails, setActiveDetails] = useState('1');
  const [lastClickedXY, setLastClickedXY] = useState({});
  const [svgDimensions, setSvgDimensions] = useState({ width: 0, height: 0 });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalView, setIsModalView] = useState(false);
  const [formObject, setFormObject] = useState({});
  const [HMITypeList, setHMITypeList] = useState([]);
  const [isHighlighted, setIsHighlighted] = useState(true);
  const [ModalAnimationsOpen, setModalAnimationsOpen] = useState(false);
  const [isModalStaticOpen, setIsModalStaticOpen] = useState(false);
  const [formValue, setFormValue] = useState({});
  const [formObjectSann, setFormObjectSann] = useState({});
  const [animationsformObject, setAnimationsformObject] = useState({});
  const [formObjectStatic, setFormObjectStatic] = useState({});
  const [currentIndex, setCurrentIndex] = useState(null);
  const [currentValue, setCurrentValue] = useState(null);
  const [currentEditIndex, setCurrentEditIndex] = useState(null);
  const [currentStaticIndex, setCurrentStaticIndex] = useState(null);
  const [hmiData, setHmiData] = useState("");
  const [editType, setEditType] = useState('Form');
  const [listType, setListType] = useState('');
  const [type, setType] = useState('Device');
  const [enable, setEnable] = useState(false);
  const [deviceSelectionType ,setDeviceSelectionType] = useState([]);
  const hmiRef = useRef();
  const hForm = useRef();
  const annRef = useRef();
  const sannoRef = useRef();
  const staticRef = useRef();
  const hAnim = useRef();
  const editorRef = useRef(null);
  const monacoRef = useRef(null);
  const searchInputRef = useRef(null);
  // const dynamicConfig =  useRef(null);

  const onClose = () => {
    if (hmiRef.current || hForm.current) {
      hmiRef.current && hmiRef.current.resetFields();
      hForm.current && hForm.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
    setImageUrl('');
    setImagebaseUrl('');
    setDefaultFileList([]);
    setFormObject({});
    setImageDetails({});
    setSvgDimensions({});
    setEditEditor({});
    setType("");
    setDeviceSelectionType([]);
    setLastClickedXY({});
  };

  const addNewHmi = () => {
    let initial = {};
    if (hmiRef.current || hForm.current) {
      hmiRef.current && hmiRef.current.resetFields();
      hForm.current &&
        hForm.current.setFieldsValue({
          filename: '',
          background: '',
          Url: '',
          viewbox: '',
          width: '',
          height: '',
          fill: '',
          fontWeight: '',
          fontFamily: '',
          intervalOperation: '',
          intervalOnchange: '',
          dataSource: '',
          frequency: '',
          codeType: '',
          groupValue1: '',
          groupValue2: '',
          warningCondition: '',
          showGoBack: '',
          // type:"",
          selectionType:[],
          method :""
          // type:'Device'
        });
      initial = {
        filename: '',
        background: '',
        Url: '',
        viewbox: '',
        width: '',
        height: '',
        fill: '',
        fontWeight: '',
        fontFamily: '',
        intervalOperation: '',
        intervalOnchange: '',
        dataSource: '',
        frequency: '',
        codeType: '',
        groupValue1: '',
        groupValue2: '',
        warningCondition: '',
        showGoBack: '',
        // type: "",
        selectionType: [],
        method:""
        // type:'Device',
      };
    }
    setType(type);
    setDeviceSelectionType([]);
    setVisible(true);
    setEditObj({});
    setEditEditor({});
    setFormObject(initial);
    setSvgDimensions({});
    setImageDetails({});
    setImagebaseUrl('');
    setActiveDetails('1');
    setLastClickedXY({});
    setListType('save');
  };

  useEffect(() => {
    _getHmiList();
    getHMITypeAPIs();
    // getDataSelectionType();
  }, []);

  useEffect(() => {
    if (formObject?.api) {
      const payloadList = Object.entries(formObject.api.payload).map(([key, value]) => ({
        key,
        value: typeof value === 'object' ? JSON.stringify(value, null, 2) : value
      }));

      hForm.current?.setFieldsValue({ payloadList });
      setEditEditor((prev) => ({
        ...prev
      }));
    }
  }, [formObject]);


  useEffect(() => {
    if (props.UserDetails !== userId) {
      setUserId(props.UserDetails);
    }
    if (props.translationCache !== translationCache || props.userProfile !== userProfile) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }
  }, [props.UserDetails, props.translationCache, props.userProfile]);

  const _getHmiList = async () => {
    const siteId = localStorage.get('currentSite');
    const payload = {
      method: 'GET',
      url: `${API_HMI.GET}?SiteId=${siteId}`
    };
    const datasource = await getHMICalls(payload);
    if (datasource && datasource.message) {
      message.info(datasource.message);
    } else {
      if (hForm.current) {
        hForm.current.setFieldsValue({
          background: recordData?.JSON?.background,
          Url: recordData?.JSON?.Url,
          viewbox: recordData?.JSON?.viewbox,
          width: recordData?.JSON?.width,
          height: recordData?.JSON?.height,
          fill: recordData?.JSON?.fill,
          fontWeight: recordData?.JSON?.fontWeight,
          fontFamily: recordData?.JSON?.fontFamily,
          intervalOperation: recordData?.JSON?.intervalOperation,
          intervalOnchange: recordData?.JSON?.intervalOnchange,
          dataSource: recordData?.JSON?.dataSource,
          frequency: recordData?.JSON?.frequency,
          codeType: recordData?.JSON?.codeType,
          groupValue1: recordData?.JSON?.groupValue1,
          groupValue2: recordData?.JSON?.groupValue2,
          warningCondition: recordData?.JSON?.warningCondition,
          type: recordData?.JSON?.type,
          // selectionType :recordData?.JSON?.selectionType,
          method: recordData?.JSON?.api?.method,
          url: recordData?.JSON?.api?.url,
          payload: JSON.stringify(recordData?.JSON?.api?.payload)
        });
      }
      setType(recordData?.JSON?.type);
      setDeviceSelectionType(recordData?.JSON?.selectionType);
      setDatasource(datasource);
      setFormObject(formObject);
    }
  };

  const getHMITypeAPIs = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const hmiMappingObject = {
      method: 'POST',
      url: `${API_MASTERCONFIGURATION.Master}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { MasterCode: 'HMI_Types', ActionType: 'read', Type: 'WithoutSiteId' }
    };
    setLoading(true);
    axios(hmiMappingObject)
      .then((response) => {
        setHMITypeList(response.data || {});
      })
      .catch(() => { });
  };

  const handleEditorDidMount = (editor, monaco) => {
    editorRef.current = editor;
    monacoRef.current = monaco;

    // Listen for changes
    const handleChanges = () => {
      const currentValue = editor.getValue();
      try {
        const parsedValue = JSON.parse(currentValue);
        setEditEditor(parsedValue); // Update state with new JSON value
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    };

    editor.onDidChangeModelContent(handleChanges);
  };

  const handleEditorChange = (value) => {
    try {
      const jsonValue = JSON.parse(value);
      setEditEditor(jsonValue);
    } catch (error) {
      message.error('Invalid JSON format. Please use double quotes for property names.');
    }
  };

  const hmiOperation = async (operation, userId) => {
    let datasource;
    const siteId = localStorage.get('currentSite');
    const validateAndReset = async () => {
      const hmiValues = await hmiRef.current.validateFields();
      const formValues = (await hForm.current) && hForm.current.validateFields();
      return { hmiValues, formValues };
    };

    if (operation === 'save') {
      validateAndReset().then(async ({ hmiValues }) => {
        if (editEditor !== 'string') {
          const payload = {
            method: 'POST',
            url: `${API_HMI.CREATE}?SiteId=${siteId}`,
            data: {
              Name: hmiValues.Name,
              Type: hmiValues.Type,
              ...imageDetails,
              JSON: editEditor,
              CreatedBy: userId,
              SiteId: siteId
            }
          };
          datasource = await getHMICalls(payload);
          if (datasource && datasource.message) {
            message.success(datasource.message);
            _getHmiList();
            onClose();
          } else {
            onClose();
            _getHmiList();
          }
        } else {
          alert('Error');
        }
      });
    } else if (operation === 'update') {
      validateAndReset().then(async ({ hmiValues }) => {
        if (editEditor !== 'string') {
          const payload = {
            method: 'PATCH',
            url: `${API_HMI.UPDATE}?SiteId=${siteId}`,
            data: {
              Name: hmiValues.Name,
              Type: hmiValues.Type,
              JSON: editEditor,
              ModifiedBy: userId,
              ...imageDetails,
              Id: editObj.Id,
              SiteId: siteId
            }
          };
          datasource = await getHMICalls(payload);
          if (datasource && datasource.message) {
            message.success(datasource.message);
            _getHmiList();
            onClose();
          } else {
            onClose();
            _getHmiList();
          }
        }
      });
    } else if (operation === 'delete') {
      validateAndReset().then(async () => {
        const payload = {
          method: 'DELETE',
          url: `${API_HMI.DELETE}?SiteId=${siteId}&Id=${editObj.Id}`
        };
        datasource = await getHMICalls(payload);
        if (datasource && datasource.message) {
          message.success(datasource.message);
          _getHmiList();
          onClose();
        } else {
          onClose();
          _getHmiList();
        }
      });
    }
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file } = options;
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const fmData = new FormData();
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` }
    };
    fmData.append('file', file);
    try {
      const res = await axios.post(`${API_HMI.SVGUpload}?SiteId=${siteId}`, fmData, config);
      onSuccess('Ok');
      setImageDetails(res.data);
      setEnable(true);
    } catch (err) {
      message.error('Error occurred while uploading');
      setEnable(enable);
      onError({ err });
    }
  };

  const handleOnChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, (url) => {
        getBase64ImageDimensions(url)
          .then((dimensions) => {
            const svgDimensions = { width: dimensions.width, height: dimensions.height };
            const viewBOX = `0 0 ${dimensions.width} ${dimensions.height}`;
            hForm.current && hForm.current.setFieldsValue({
              width: dimensions.width,
              height: dimensions.height,
              viewbox: viewBOX
            });
            setSvgDimensions(svgDimensions);
            setEditEditor({
              ...editEditor,
              width: dimensions.width,
              height: dimensions.height,
              viewbox: viewBOX
            });
            setFormObject({
              ...formObject,
              width: dimensions.width,
              height: dimensions.height,
              viewbox: viewBOX
            });
          })
          .catch((error) => {
            console.error(error);
          });
        setLoading(loading);
        setImagebaseUrl(url);
      });
    }
  };

  const beforeUpload = (file) => {
    const isSvg = file.type === 'image/svg+xml';
    if (!isSvg) {
      message.error('You can only upload SVG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must be smaller than 2MB!');
    }
    return isSvg && isLt2M;
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const getBase64ImageDimensions = (base64String) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = function () {
        reject(new Error('Failed to load image'));
      };
      img.src = base64String; // Assign Base64 string
    });
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    ),
  });

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getSvgDimensions = async (url) => {
    try {
      const response = await fetch(url);
      const svgText = await response.text();
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
      const svgElement = svgDoc.documentElement;
      let width = svgElement.getAttribute('width');
      let height = svgElement.getAttribute('height');
      const viewBox = svgElement.getAttribute('viewBox');

      if (!width || !height) {
        if (viewBox) {
          const viewBoxValues = viewBox.split(' ');
          width = viewBoxValues[2];
          height = viewBoxValues[3];
        }
      }

      return { width, height };
    } catch (error) {
      console.error('Error fetching SVG dimensions:', error);
    }
  };

  const openAddAnnotationModal = () => {
    annRef.current && annRef.current.setFieldsValue({
      x: lastClickedXY.x !== null ? lastClickedXY.x : '',
      y: lastClickedXY.y !== null ? lastClickedXY.y : '',
      parameter: '',
      type: '',
      fontsize: '',
      fontfamily: '',
      fontweight: '',
      className: '',
      group: '',
      groupValue: '',
      fill: '',
      payloadType: '',
      decimalLength: '',
      alignment: '',
      device: ''
    });
    const annObj = {
      x: lastClickedXY.x,
      y: lastClickedXY.y
    };
    setIsModalView(true);
    setFormValue(annObj);
  };

  const openAddShapeannotationModal = () => {
    sannoRef.current && sannoRef.current.setFieldsValue({
      x: lastClickedXY.x !== null ? lastClickedXY.x : '',
      y: lastClickedXY.y !== null ? lastClickedXY.y : '',
      rx: '',
      ry: '',
      cx: '',
      cy: '',
      r: '',
      width: '',
      height: '',
      device: '',
      parameter: '',
      fill: '',
      type: ''
    });
    const shapeObj = {
      x: lastClickedXY.x,
      y: lastClickedXY.y
    };
    setIsModalOpen(true);
    setFormObjectSann(shapeObj);
  };

  const modalOpen = () => {
    hAnim.current && hAnim.current.setFieldsValue({
      x: lastClickedXY.x !== null ? lastClickedXY.x : '',
      y: lastClickedXY.y !== null ? lastClickedXY.y : '',
      width: '',
      height: '',
      parameter: '',
      device: '',
      payload: '',
      type: '',
      imagePrefix: ''
    });
    const animationObj = {
      x: lastClickedXY.x,
      y: lastClickedXY.y
    };
    setModalAnimationsOpen(true);
    setAnimationsformObject(animationObj);
  };

  const openAddStaticannotationModal = () => {
    staticRef.current && staticRef.current.setFieldsValue({
      x: lastClickedXY.x !== null ? lastClickedXY.x : '',
      y: lastClickedXY.y !== null ? lastClickedXY.y : '',
      fontSize: '',
      mappingKey: ''
    });
    const staticObj = {
      x: lastClickedXY.x,
      y: lastClickedXY.y
    };
    setIsModalStaticOpen(true);
    setFormObjectStatic(staticObj);
  };

  const onChangeData = (e, key) => {
    const data = e.target && e.target.value;
    setEditEditor((prev) => ({
      ...prev,
      [key]: data
    }));
    setFormObject((prev) => ({
      ...prev,
      [key]: data
    }));
  };

  const onChangeValue = (value, key) => {
    let formData = hForm.current && hForm.current.getFieldsValue();
    let InitialData = {
      ...formData,
      type: value === 'Asset' ? 'Asset' : 'Device'
    };
    setType(InitialData.type);
    setEditEditor((prev) => ({
      ...prev,
      [key]: value
    }));
    setFormObject(InitialData);
    // setFormObject({
    //   ...InitialData
    // });
  };

  const onChangeValueData = (value, key) => {

    let formData = hForm.current && hForm.current.getFieldsValue();
    const api = formData?.api?.method || 'GET';

    // let InitialData = {
    //   ...formData,
    // };
    setEditEditor((prev) => ({
      ...prev,
      [key]: value,
      api: {
        ...prev.api,
        method: value,
      },
    }));
    // setFormObject(InitialData);
    hForm.current?.setFieldsValue({
      ...formData,
      api: {
        ...api,
        method: value,
      },
    });
  };

  const onChangeAnnotations = (e, key) => {
    const value = e.target.value;
    const FormValue = annRef.current && annRef.current.getFieldsValue();
    setFormValue({
      ...FormValue,
      [key]: value
    });
  };

  const onChangeShapennotations = (e, key) => {
    const value = e.target.value;
    const FormObjectSann = sannoRef.current && sannoRef.current.getFieldsValue();
    setFormObjectSann({
      ...FormObjectSann,
      [key]: value
    });
  };

  const onChangeAnimations = (e, key) => {
    const value = e.target.value;
    const animationsformObject = hAnim.current && hAnim.current.getFieldsValue();
    setAnimationsformObject({
      ...animationsformObject,
      [key]: value
    });
  };

  const onChangeStaticannotations = (e, key) => {
    const value = e.target.value;
    const FormObjectStatic = staticRef.current && staticRef.current.getFieldsValue();
    setFormObjectStatic({
      ...FormObjectStatic,
      [key]: value
    });
  };

  const editAnnotations = (record, index) => {
    annRef.current && annRef.current.setFieldsValue({
      x: record.x,
      y: record.y,
      parameter: record.parameter,
      type: record.type,
      fontsize: record.fontsize,
      fontfamily: record.fontfamily,
      fontweight: record.fontweight,
      className: record.className,
      group: record.group,
      groupValue: record.groupValue,
      fill: record.fill,
      payload: record.payload,
      decimalLength: record.decimalLength,
      alignment: record.alignment,
      device: record.device
    });
    setIsModalView(true);
    setCurrentValue(index);
    setFormValue(record);
  };

  const editShapeAnnotations = (record, index) => {
    sannoRef.current && sannoRef.current.setFieldsValue({
      x: record.x,
      y: record.y,
      rx: record.rx,
      ry: record.ry,
      cx: record.cx,
      cy: record.cy,
      r: record.r,
      width: record.width,
      height: record.height,
      device: record.device,
      parameter: record.parameter,
      fill: record.fill,
      type: record.type
    });
    setIsModalOpen(true);
    setCurrentIndex(index);
    setFormObjectSann(record);
  };

  const showModal = (record, index) => {
    hAnim.current && hAnim.current.setFieldsValue({
      x: record.x,
      y: record.y,
      width: record.width,
      height: record.height,
      parameter: record.parameter,
      device: record.device,
      payload: record.payload,
      type: record.type,
      imagePrefix: record.imagePrefix
    });
    setModalAnimationsOpen(true);
    setCurrentEditIndex(index);
    setAnimationsformObject(record);
  };

  const editStaticAnnotations = (record, index) => {
    staticRef.current && staticRef.current.setFieldsValue({
      x: record.x,
      y: record.y,
      fontSize: record.fontSize,
      mappingKey: record.mappingKey
    });
    setIsModalStaticOpen(true);
    setCurrentStaticIndex(index);
    setFormObjectStatic(record);
  };

  const ModalAnnotationOk = () => {
    annRef.current
      .validateFields()
      .then((values) => {
        if (currentValue !== null) {
          // Edit existing annotation
          const updatedAnnotations = editEditor.annotations
            ? [...editEditor.annotations]
            : [];
          updatedAnnotations[currentValue] = values;
          const cleanedData = removeEmptyKeys(updatedAnnotations);
          setEditEditor(prev => ({
            ...prev,
            annotations: cleanedData
          }));
          setIsModalView(false);
          setCurrentValue(null);
        } else if (!editEditor.annotations || editEditor.annotations.length === 0) {
          // Add first annotation
          const updatedAnnotations = [{ ...values }];
          setEditEditor(prev => ({
            ...prev,
            annotations: updatedAnnotations
          }));
          setIsModalView(false);
          setCurrentValue(null);
        } else {
          // Add new annotation
          const updatedAnnotations = editEditor.annotations
            ? [...editEditor.annotations]
            : [];
          updatedAnnotations.push(values);
          const cleanedData = removeEmptyKeys(updatedAnnotations);
          setEditEditor(prev => ({
            ...prev,
            annotations: cleanedData
          }));
          setIsModalView(false);
        }
      })
      .catch((error) => {
        console.error('Validation failed:', error);
      });
  };

  const ModalShapeAnnotationOk = () => {
    sannoRef.current
      .validateFields()
      .then((values) => {
        if (currentIndex !== null) {
          // Edit existing shape annotation
          const updatedShapeannotations = editEditor.shapesannotations
            ? [...editEditor.shapesannotations]
            : [];
          updatedShapeannotations[currentIndex] = values;
          const cleanedData = removeEmptyKeys(updatedShapeannotations);
          setEditEditor(prev => ({
            ...prev,
            shapesannotations: cleanedData
          }));
          setIsModalOpen(false);
          setCurrentIndex(null);
        } else if (!editEditor.shapesannotations || editEditor.shapesannotations.length === 0) {
          const updatedShapeannotations = [{ ...values }];
          setEditEditor(prev => ({
            ...prev,
            shapesannotations: updatedShapeannotations
          }));
          setIsModalOpen(false);
          setCurrentIndex(null);
        } else {
          const updatedShapeannotations = editEditor.shapesannotations
            ? [...editEditor.shapesannotations]
            : [];
          updatedShapeannotations.push(values);
          const cleanedData = removeEmptyKeys(updatedShapeannotations);
          setEditEditor(prev => ({
            ...prev,
            shapesannotations: cleanedData
          }));
          setIsModalOpen(false);
        }
      })
      .catch((error) => {
        console.error('Validation failed:', error);
      });
  };

  const removeEmptyKeys = (array) => {
    return array.map((obj) => {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            value !== '' &&
            key !== ' ' &&
            key !== undefined
        )
      );
    });
  };

  const ModalOnOk = () => {
    hAnim.current && hAnim.current
      .validateFields()
      .then((values) => {
        if (currentEditIndex !== null) {
          // Edit existing shape annotation
          const updatedStaticAnnotations = editEditor.animations
            ? [...editEditor.animations]
            : [];
          updatedStaticAnnotations[currentEditIndex] = values;
          const cleanedData = removeEmptyKeys(updatedStaticAnnotations);
          setEditEditor(prev => ({
            ...prev,
            animations: cleanedData
          }));
          setModalAnimationsOpen(false);
          setCurrentEditIndex(null);
        } else if (!editEditor.animations || editEditor.animations.length === 0) {
          const updatedShapeannotations = [{ ...values }];
          setEditEditor(prev => ({
            ...prev,
            animations: updatedShapeannotations
          }));
          setModalAnimationsOpen(false);
          setCurrentEditIndex(null);
        } else {
          const updatedStaticannotations = editEditor.animations
            ? [...editEditor.animations]
            : [];
          updatedStaticannotations.push({ ...values });
          const cleanedData = removeEmptyKeys(updatedStaticannotations);
          setEditEditor(prev => ({
            ...prev,
            animations: cleanedData
          }));
          setModalAnimationsOpen(false);
        }
      })
      .catch((error) => {
        console.error('Validation failed:', error);
      });
  };

  const StaticOnOk = () => {
    staticRef && staticRef.current
      .validateFields()
      .then((values) => {
        if (currentStaticIndex !== null) {
          // Edit existing shape annotation
          const updatedStaticAnnotations = editEditor.staticannotations
            ? [...editEditor.staticannotations]
            : [];
          updatedStaticAnnotations[currentStaticIndex] = values;
          const cleanedData = removeEmptyKeys(updatedStaticAnnotations);
          setEditEditor(prev => ({
            ...prev,
            staticannotations: cleanedData
          }));
          setIsModalStaticOpen(false);
          setCurrentStaticIndex(null);
        } else if (!editEditor.staticannotations || editEditor.staticannotations.length === 0) {
          const updatedShapeannotations = [{ ...values }];
          setEditEditor(prev => ({
            ...prev,
            staticannotations: updatedShapeannotations
          }));
          setIsModalStaticOpen(false);
          setCurrentStaticIndex(null);
        } else {
          const updatedStaticannotations = editEditor.staticannotations
            ? [...editEditor.staticannotations]
            : [];
          updatedStaticannotations.push({ ...values });
          const cleanedData = removeEmptyKeys(updatedStaticannotations);
          setEditEditor(prev => ({
            ...prev,
            staticannotations: cleanedData
          }));
          setIsModalStaticOpen(false);
        }
      })
      .catch((error) => {
        console.error('Validation failed:', error);
      });
  };

  const ModalAnn = () => {
    annRef.current && annRef.current.resetFields();
    setIsModalView(false);
  };

  const Modalshape = () => {
    sannoRef.current && sannoRef.current.resetFields();
    setIsModalOpen(false);
  };

  const ModalCancel = () => {
    hAnim.current && hAnim.current.resetFields();
    setModalAnimationsOpen(false);
    setCurrentEditIndex(null);
  };

  const onStaticCancel = () => {
    staticRef.current && staticRef.current.resetFields();
    setIsModalStaticOpen(false);
    setCurrentStaticIndex(null);
  };

  const formOnclick = () => {
    setEditType('Form');
    setIsHighlighted(true);
  };

  const JsonOnclick = () => {
    setEditType('JSON');
    setIsHighlighted(false);
  };

  const datasourceAnimations = editEditor.animations || [];
  const annotationsData = editEditor.annotations || [];
  const shapesannotationsData = editEditor.shapesannotations || [];
  const staticannotationsData = editEditor.staticannotations || [];

  const columnsAnimations = [
    {
      title: 'X',
      dataIndex: 'x',
      key: 'x'
    },
    {
      title: 'Y',
      dataIndex: 'y',
      key: 'y'
    },
    {
      title: 'Parameter',
      dataIndex: 'parameter',
      key: 'parameter'
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (_text, record, index) => (
        <div>
          <Button
            className="ant-btn"
            style={{ marginRight: '5px' }}
            onClick={() => showModal(record, index)}
          >
            More...
          </Button>
        </div>
      )
    }
  ];
  const annotationscolumns = [
    {
      title: 'X',
      dataIndex: 'x',
      key: 'x'
    },
    {
      title: 'Y',
      dataIndex: 'y',
      key: 'y'
    },
    {
      title: 'Parameter',
      dataIndex: 'parameter',
      key: 'parameter'
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: 'Action',
      dataIndex: 'Action',
      key: 'Action',
      render: (_text, record, index) => (
        <div>
          <Button
            type="Button"
            onClick={() => editAnnotations(record, index)}
            style={{ marginRight: '10px' }}
            className="ant-btn"
          >
            More...
          </Button>
        </div>
      )
    }
  ];
  const shapeannotationscoloumns = [
    {
      title: 'X',
      dataIndex: 'x',
      key: 'x'
    },
    {
      title: 'Y',
      dataIndex: 'y',
      key: 'y'
    },
    {
      title: 'Parameter',
      dataIndex: 'parameter',
      key: 'parameter'
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type'
    },

    {
      title: 'Action',
      dataIndex: 'Action',
      key: 'Action',
      render: (_text, record, index) => (
        <div>
          <Button
            type="Button"
            onClick={() => editShapeAnnotations(record, index)}
            style={{ marginRight: '10px' }}
            className="ant-btn"
          >
            More...
          </Button>
        </div>
      )
    }
  ];
  const staticannotationscoloumns = [
    {
      title: 'X',
      dataIndex: 'x',
      key: 'x'
    },
    {
      title: 'Y',
      dataIndex: 'y',
      key: 'y'
    },
    {
      title: 'Font Size',
      dataIndex: 'fontSize',
      key: 'fontSize'
    },
    {
      title: 'Mapping Key',
      dataIndex: 'mappingKey',
      key: 'mappingKey'
    },
    {
      title: 'Action',
      dataIndex: 'Action',
      key: 'Action',
      render: (_text, record, index) => (
        <div>
          <Button
            type="Button"
            onClick={() => editStaticAnnotations(record, index)}
            style={{ marginRight: '10px' }}
            className="ant-btn"
          >
            More...
          </Button>
        </div>
      )
    }
  ];
  const columns = [
    {
      title:
        translationCache && translationCache[`${constant.HMI_Name}`]
          ? translationCache[`${constant.HMI_Name}`]
          : `${constant.HMI_Name}`,
      dataIndex: 'Name',
      key: 'Name',
      width: '50%',
      ...getColumnSearchProps('Name'),
      render: (text, record) => {
        return (
          <Link
            to={{
              pathname: `/rubus/HMI/${record.Type}/${record.Name}${record.Type === 'dynamic' 
                || record.Type === 'distinct' ? `/${record?.JSON?.selectionType}` : ''
                }/${record.Type === 'dynamic' 
                || record.Type === 'distinct' ? record.JSON.type :''}`
            }}
          >
            {text}
          </Link>
        );
      }
    },
    {
      title:
        translationCache && translationCache[`${constant.HMI_Type}`]
          ? translationCache[`${constant.HMI_Type}`]
          : `${constant.HMI_Type}`,
      dataIndex: 'Type',
      key: 'Type',
      ...getColumnSearchProps('Type')
    },
    {
      title:
        translationCache && translationCache[`${constant.File_Name}`]
          ? translationCache[`${constant.File_Name}`]
          : `${constant.File_Name}`,
      dataIndex: 'FileName',
      key: 'FileName',
      ...getColumnSearchProps('FileName')
    }
  ];
  const UserId = UserDetails && UserDetails.Id;
  // const options = {
  //   selectOnLineNumbers: true,
  //   roundedSelection: false,
  //   readOnly: false,
  //   cursorStyle: 'line',
  //   automaticLayout: false,
  //   lineDecorationsWidth: 0
  // };
  const siteId = localStorage.get('currentSite');
  const permissionsArray = [];
  userProfile &&
    userProfile['belongsTo'] &&
    userProfile['belongsTo']['sites'] &&
    userProfile['belongsTo']['sites'][siteId] &&
    userProfile['belongsTo']['sites'][siteId]['role'] &&
    userProfile['belongsTo']['sites'][siteId]['role']['Permission']
      .filter((item) => item.resource === 'hmi')
      .map((name) => permissionsArray.push(name.action));

  return (
    <>
      <div style={{
        display: 'flex',
        flexDirection: 'row-reverse'
      }}>
        <Button
          type='primary'
          style={{ marginBottom: '15px' }}
          onClick={addNewHmi}
        >
          <PlusOutlined />
          <span>
            {translation(`${constant.New_HMI}`)}
          </span>
        </Button>
      </div>
      <Drawer
        title={translation('Create a new HMI configuration')}
        width={1700}
        closable
        onClose={onClose}
        open={visible}
        style={{ paddingBottom: 80 }}
      >
        <Form
          layout="vertical"
          ref={hmiRef}
          hideRequiredMark
          initialValues={editObj || {}}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 24 }}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col   span={18}>
              <Form.Item
                label={translation('HMI Name')}
                name="Name"
                rules={[{ required: true, message: 'Enter HMI Name' }]}
              >
                <Input
                  placeholder={translation('Please enter HMI Name')}
                  disabled={!editObj.Name ? false : true}
                />
              </Form.Item>
              <Form.Item
                label={translation('HMI Type')}
                name="Type"
                rules={[{ required: true, message: 'Please enter HMI Type' }]}
              >
                <Select
                  placeholder={translation('Select HMI Type')}
                  disabled={!editObj.Type ? false : true}
                  onSelect={(value) => {
                    setHmiData(value);
                  }}
                >
                  {HMITypeList &&
                    Array.isArray(HMITypeList) &&
                    HMITypeList.map((hmi, index) => (
                      <Option key={index} value={hmi.HMIType}>
                        {hmi.HMIType}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item label={translation('Upload')} name="fileList">
                <Upload
                  name="avatar"
                  showUploadList={false}
                  accept="image/svg+xml"
                  customRequest={uploadImage}
                  beforeUpload={beforeUpload}
                  onChange={handleOnChange}
                  defaultFileList={defaultFileList}
                >
                  <Button icon={<UploadOutlined />}>Upload SVG file</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <div>
          Last clicked coordinates:
          {lastClickedXY && lastClickedXY.x && lastClickedXY.y ? (
            <span>
              x: {lastClickedXY.x}, y: {lastClickedXY.y}
            </span>
          ) : ''}
        </div>
        <svg
          viewBox={`0 0 ${svgDimensions.width} ${svgDimensions.height}`}
          onClick={(event) => {
            const rect = event.target.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            setLastClickedXY({ x, y });
          }}
        >
          <image
            href={`${imagebaseUrl ? imagebaseUrl : imageUrl}`}
            width={svgDimensions.width}
            height={svgDimensions.height}
          />
        </svg>
        <div>{translation('Enter HMI JSON')}</div>
        <div style={{ float: 'right' }}>
          <Button
            style={{
              marginRight: '10px',
              color: isHighlighted ? '#1890ff' : 'black'
            }}
            onClick={formOnclick}
          >
            Form
          </Button>
          <Button onClick={JsonOnclick}>JSON</Button>
        </div>
        {editType === 'Form' ? (
          <Tabs
            className="List"
            type="card"
            style={{ marginTop: '40px' }}
            defaultActiveKey="1"
            activeKey={activeDetails}
            onChange={setActiveDetails}
          >
            <TabPane tab="Initial Tab" key="1">
              <Form
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 12 }}
                ref={hForm}
                name="Site_form"
                initialValues={formObject || {}}
              >
                <Form.Item name={'Id'}></Form.Item>
                <Row gutter={16}>
                  <Col span={10}>
                    <Form.Item label="FileName" name="filename">
                      <Input defaultValue={imageDetails.FileName} readOnly />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      label="Background"
                      name="background"
                      rules={[{ required: true, message: 'Please input your Background' }]}
                    >
                      <Input
                        value={formObject.background || ''}
                        onChange={(e) => onChangeData(e, 'background')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      label="URL"
                      name="Url"
                      rules={[{ required: true, message: 'Please input your URL' }]}
                    >
                      <Input
                        value={formObject.Url || ''}
                        onChange={(e) => onChangeData(e, 'Url')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      label="View Box"
                      name="viewbox"
                      rules={[{ required: true, message: 'Please input your ViewBox' }]}
                    >
                      <Input defaultValue={editEditor.viewbox || ''} />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      label="Width"
                      name="width"
                      rules={[{ required: true, message: 'Please input your width' }]}
                    >
                      <Input defaultValue={editEditor.width || ''} />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      label="Height"
                      name="height"
                      rules={[{ required: true, message: 'Please input your height' }]}
                    >
                      <Input defaultValue={editEditor.height || ''} />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Fill" name="fill">
                      <Input
                        value={formObject.fill || ''}
                        onChange={(e) => onChangeData(e, 'fill')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      label="Font Weight"
                      name="fontWeight"
                      rules={[{ required: true, message: 'Please input your fontweight' }]}
                    >
                      <Input
                        value={formObject.fontWeight || ''}
                        onChange={(e) => onChangeData(e, 'fontWeight')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      label="Font Family"
                      name="fontFamily"
                      rules={[{ required: true, message: 'Please input your fontfamily' }]}
                    >
                      <Input
                        value={formObject.fontFamily || ''}
                        onChange={(e) => onChangeData(e, 'fontFamily')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Interval Operation" name="intervalOperation">
                      <Input
                        value={formObject.intervalOperation || ''}
                        onChange={(e) => onChangeData(e, 'intervalOperation')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Interval Onchange" name="intervalOnchange">
                      <Input
                        value={formObject.intervalOnchange || ''}
                        onChange={(e) => onChangeData(e, 'intervalOnchange')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="DataSource" name="dataSource">
                      <Input
                        value={formObject.dataSource || ''}
                        onChange={(e) => onChangeData(e, 'dataSource')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      label="Frequency"
                      name="frequency"
                      rules={[{ required: true, message: 'Please input your frequency' }]}
                    >
                      <Input
                        value={formObject.frequency || ''}
                        onChange={(e) => onChangeData(e, 'frequency')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Code Type" name="codeType">
                      <Input
                        value={formObject.codeType || ''}
                        onChange={(e) => onChangeData(e, 'codeType')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Group Value1" name="groupValue1">
                      <Input
                        value={formObject.groupValue1 || ''}
                        onChange={(e) => onChangeData(e, 'groupValue1')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Group Value2" name="groupValue2">
                      <Input
                        value={formObject.groupValue2 || ''}
                        onChange={(e) => onChangeData(e, 'groupValue2')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item name="type" label="Type">
                      <Select onChange={(value) => onChangeValue(value, 'type')}>
                        <Option value="Device">Device</Option>
                        <Option value="Asset">Asset</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                   <Col span={10}>
                    <Form.Item name="selectionType" label=" Selection Type">
                      <Select
                        onChange={(value) => onChangeValue(value, 'selectionType')}
                      >
                        {deviceSelectionType &&
                          Array.isArray(deviceSelectionType) &&
                          deviceSelectionType.map((data, index) => (
                            <Option key={index} value={data.Value}>
                              {data.Value}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Warning Condition" name="warningCondition">
                      <Input
                        value={formObject.warningCondition || ''}
                        onChange={(e) => onChangeData(e, 'warningCondition')}
                      />
                    </Form.Item>
                  </Col>
                   <Col span={10}>
                    <Form.Item name="url" label="API_URL">
                      <Input
                        defaultValue={formObject?.api?.url || ''}
                        onChange={(e) => onChangeData(e, 'url')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item name="method" label="API_Method">
                      <Select onChange={(value) => onChangeValueData(value,"method")}>
                        <Option value="GET">GET</Option>
                        <Option value="POST">POST</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                   <Col span={10}>
                    <Form.Item label="API Payload">
                      <Form.List name="payloadList">
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, ...restField }) => (
                              <Space key={key} style={{ display: 'flex', marginBottom: 5 }} align="baseline">
                                <Form.Item
                                  {...restField}
                                  name={[name, 'key']}
                                  rules={[{ required: true, message: 'Missing key' }]}
                                >
                                  <Input placeholder="Key (e.g., TableName)" />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'value']}
                                  rules={[{ required: true, message: 'Missing value' }]}
                                >
                                  <Input.TextArea style={{ width: '100%', marginLeft: '30px', height: '10px' }} placeholder="Value (can be JSON)" maxLength={100} />
                                </Form.Item>
                                <MinusCircleOutlined onClick={() => remove(name)} />
                              </Space>
                            ))}

                            <Form.Item>
                              <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                Add Key-Value Pair
                              </Button>
                            </Form.Item>
                          </>
                        )}
                      </Form.List>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </TabPane>
            <TabPane tab="Annotations" key="2">
              <Button
                type="primary"
                onClick={openAddAnnotationModal}
                style={{ margin: '8px' }}
                icon={<PlusOutlined />}
              >
                Add
              </Button>
              <StyledTable size="small"
                columns={annotationscolumns}
                dataSource={annotationsData && Array.isArray(annotationsData) ? annotationsData : []}
              />
              <Modal
                width={'800px'}
                title={'Annotations'}
                open={isModalView}
                okText={currentValue !== null ? 'Update' : 'Create'}
                onOk={ModalAnnotationOk}
                onCancel={ModalAnn}
              >
                <Form
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 12 }}
                  layout="basic"
                  ref={annRef}
                  initialValues={formValue || {}}
                >
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="X"
                        name="x"
                        rules={[{ required: true, message: `x is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'x')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Y"
                        name="y"
                        rules={[{ required: true, message: `y is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'y')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Font Weight"
                        name="fontweight"
                        rules={[{ required: false, message: `fontweight is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'fontWeight')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Font Size"
                        name="fontsize"
                        rules={[{ required: false, message: `fontsize is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'fontsize')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Font Family"
                        name="fontfamily"
                        rules={[{ required: false, message: `fontfamily is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'fontfamily')} />
                      </Form.Item>
                    </Col>
                    {hmiData === 'static' ? (
                      <>
                        <Col span={12}>
                          <Form.Item
                            label="Device"
                            name="device"
                            rules={[{ required: true, message: `Device is required.` }]}
                          >
                            <Input
                              onChange={(e) => onChangeAnnotations(e, 'device')}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Parameter"
                            name="parameter"
                            rules={[{ required: true, message: `Parameter is required.` }]}
                          >
                            <Input
                              onChange={(e) => onChangeAnnotations(e, 'parameter')}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ) : null}

                    <Col span={12}>
                      <Form.Item
                        label="Type"
                        name="type"
                        rules={[{ required: true, message: `type is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'type')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Fill"
                        name="fill"
                        rules={[{ required: false, message: `fill is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'fill')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Class Name"
                        name="className"
                        rules={[{ required: false, message: `classname is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'className')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Group"
                        name="group"
                        rules={[{ required: false, message: `group is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'group')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Group Value"
                        name="groupValue"
                        rules={[{ required: false, message: `groupvalue is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'groupValue')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Payload Type"
                        name="payloadType"
                        rules={[{ required: false, message: `payloadtype is required.` }]}
                      >
                        <Input onChange={(e) => onChangeAnnotations(e, 'payloadType')} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
            </TabPane>
            <TabPane tab="ShapesAnnotations" key="3">
              <Button
                type="primary"
                onClick={openAddShapeannotationModal}
                style={{ margin: '8px' }}
                icon={<PlusOutlined />}
              >
                Add
              </Button>
              <StyledTable size="small"
                columns={shapeannotationscoloumns}
                dataSource={shapesannotationsData && Array.isArray(shapesannotationsData) ? shapesannotationsData : []}
              />
              <Modal
                width={'800px'}
                title={'Shape Annotations'}
                open={isModalOpen}
                okText={currentIndex !== null ? 'Update' : 'Create'}
                onOk={ModalShapeAnnotationOk}
                onCancel={Modalshape}
              >
                <Form
                  layout="basic"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 12 }}
                  ref={sannoRef}
                  initialValues={formObjectSann || {}}
                >
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="X"
                        name="x"
                        rules={[{ required: true, message: `X is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'x')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Y"
                        name="y"
                        rules={[{ required: true, message: `y is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'y')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Type"
                        name="type"
                        rules={[{ required: true, message: `type is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'type')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="RX"
                        name="rx"
                        rules={[{ required: false, message: `rx is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'rx')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="RY"
                        name="ry"
                        rules={[{ required: false, message: `ry is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'ry')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="R"
                        name="r"
                        rules={[{ required: false, message: `r is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'r')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label=" CX"
                        name="cx"
                        rules={[{ required: false, message: `cx is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'cx')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="CY"
                        name="cy"
                        rules={[{ required: false, message: `cy is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'cy')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Width"
                        name="width"
                        rules={[{ required: false, message: `width is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'width')} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Height"
                        name="height"
                        rules={[{ required: false, message: `height is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'height')} />
                      </Form.Item>
                    </Col>
                    {hmiData === 'static' ? (
                      <>
                        <Col span={12}>
                          <Form.Item
                            label="Device"
                            name="device"
                            rules={[{ required: true, message: `Device is required.` }]}
                          >
                            <Input
                              onChange={(e) => onChangeShapennotations(e, 'device', currentValue)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Parameter"
                            name="parameter"
                            rules={[{ required: true, message: `parameter is required.` }]}
                          >
                            <Input
                              onChange={(e) => onChangeShapennotations(e, 'parameter', currentIndex)}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ) : null}
                    <Col span={12}>
                      <Form.Item
                        label="Fill"
                        name="fill"
                        rules={[{ required: false, message: `fill is required.` }]}
                      >
                        <Input onChange={(e) => onChangeShapennotations(e, 'fill')} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
            </TabPane>
            <TabPane tab="Animations" key="4">
              <Button
                type="primary"
                onClick={modalOpen}
                style={{ margin: '8px' }}
                icon={<PlusOutlined />}
              >
                Add
              </Button>
              <StyledTable size="small"
                columns={columnsAnimations}
                dataSource={datasourceAnimations && Array.isArray(datasourceAnimations) ? datasourceAnimations : []}
              />
              <Modal
                width={'800px'}
                title={'Animations'}
                closable
                open={ModalAnimationsOpen}
                okText={currentEditIndex !== null ? 'Update' : 'Create'}
                onOk={ModalOnOk}
                onCancel={ModalCancel}
              >
                <Form
                  name="basic"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 12 }}
                  ref={hAnim}
                  initialValues={animationsformObject || {}}
                >
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="X"
                        name="x"
                        rules={[{ required: true, message: 'x is required.' }]}
                      >
                        <Input
                          value={animationsformObject.x || ''}
                          onChange={(e) => onChangeAnimations(e, 'x')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Y"
                        name="y"
                        rules={[{ required: true, message: `y is required.` }]}
                      >
                        <Input
                          value={animationsformObject.y || ''}
                          onChange={(e) => onChangeAnimations(e, 'y')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Width"
                        name="width"
                        rules={[{ required: false, message: `width is required.` }]}
                      >
                        <Input
                          value={animationsformObject.width || ''}
                          onChange={(e) => onChangeAnimations(e, 'width')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Height"
                        name="height"
                        rules={[{ required: false, message: `height is required.` }]}
                      >
                        <Input
                          value={animationsformObject.height || ''}
                          onChange={(e) => onChangeAnimations(e, 'height')}
                        />
                      </Form.Item>
                    </Col>
                    {hmiData === 'static' ? (
                      <>
                        <Col span={12}>
                          <Form.Item
                            label="Device"
                            name="device"
                            rules={[{ required: true, message: `Device is required.` }]}
                          >
                            <Input
                              onChange={(e) => onChangeAnimations(e, 'device')}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Parameter"
                            name="parameter"
                            rules={[{ required: true, message: `parameter is required.` }]}
                          >
                            <Input
                              onChange={(e) => onChangeAnimations(e, 'parameter')}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ) : null}
                    <Col span={12}>
                      <Form.Item
                        label="Payload"
                        name="payload"
                        rules={[{ required: false, message: `payload is required.` }]}
                      >
                        <Input
                          value={animationsformObject.payload || ''}
                          onChange={(e) => onChangeAnimations(e, 'payload')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Type"
                        name="type"
                        rules={[{ required: true, message: `type is required.` }]}
                      >
                        <Input
                          value={animationsformObject.type || ''}
                          onChange={(e) => onChangeAnimations(e, 'type')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="ImagePrefix"
                        name="imagePrefix"
                        rules={[{ required: false, message: `imagePrefix is required.` }]}
                      >
                        <Input
                          value={animationsformObject.imagePrefix || ''}
                          onChange={(e) => onChangeAnimations(e, 'imagePrefix')}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
            </TabPane>
            <TabPane tab="Static Annotations" key="5">
              <Button
                type="primary"
                onClick={openAddStaticannotationModal}
                style={{ margin: '8px' }}
                icon={<PlusOutlined />}
              >
                Add
              </Button>
              <StyledTable size="small"
                columns={staticannotationscoloumns}
                dataSource={staticannotationsData && Array.isArray(staticannotationsData) ? staticannotationsData : []}
              />
              <Modal
                width={'800px'}
                title={'Static Annotations'}
                open={isModalStaticOpen}
                okText={currentStaticIndex !== null ? 'Update' : 'Create'}
                onOk={StaticOnOk}
                onCancel={onStaticCancel}
              >
                <Form
                  layout="basic"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 12 }}
                  ref={staticRef}
                  initialValues={formObjectStatic || {}}
                >
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="X"
                        name="x"
                        rules={[{ required: true, message: `X is required.` }]}
                      >
                        <Input
                          value={formObjectStatic.x || ''}
                          onChange={(e) => onChangeStaticannotations(e, 'x')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Y"
                        name="y"
                        rules={[{ required: true, message: `Y is required.` }]}
                      >
                        <Input
                          value={formObjectStatic.y || ''}
                          onChange={(e) => onChangeStaticannotations(e, 'y')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Font Size"
                        name="fontSize"
                        rules={[{ required: true, message: `Font Size is required.` }]}
                      >
                        <Input
                          value={formObjectStatic.fontSize || ''}
                          onChange={(e) => onChangeStaticannotations(e, 'fontSize')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Mapping Key"
                        name="mappingKey"
                        rules={[{ required: true, message: `mappingKey is required.` }]}
                      >
                        <Input
                          value={formObjectStatic.mappingKey || ''}
                          onChange={(e) => onChangeStaticannotations(e, 'mappingKey')}
                        />
                      </Form.Item>
                    </Col>
                    {hmiData === 'static' ? (
                      <>
                        <Col span={12}>
                          <Form.Item
                            label="Device"
                            name="device"
                            rules={[{ required: true, message: `Device is required.` }]}
                          >
                            <Input
                              onChange={(e) => onChangeStaticannotations(e, 'device')}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Parameter"
                            name="parameter"
                            rules={[{ required: true, message: `Parameter is required.` }]}
                          >
                            <Input
                              onChange={(e) => onChangeStaticannotations(e, 'parameter')}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ) : null}
                  </Row>
                </Form>
              </Modal>
            </TabPane>
          </Tabs>
        ) : (
          <Collapse
            bordered={false}
            style={{ marginTop: '40px' }}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0}></CaretRightOutlined>
            )}
          >
            <Editor
              width="1000px"
              height="50vh"
              theme='vs-dark'
              defaultLanguage="json"
              onChange={handleEditorChange}
              defaultValue={JSON.stringify(editEditor)}
              value={JSON.stringify(editEditor, null, 2)}
              onMount={handleEditorDidMount}
            />
          </Collapse>
        )}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {listType === 'save' ? (
            <Button
              type="primary"
              shape="round"
              onClick={() => hmiOperation('save', UserId, 'Device')}
              style={{ marginRight: '10px', marginTop: '10px' }}
            >
              {translation('Save')}
            </Button>
          ) : (
            <Button
              type="primary"
              shape="round"
              onClick={() => hmiOperation('update', UserId, 'Device')}
              style={{ marginTop: '10px' }}
            >
              {translation('Update')}
            </Button>
          )}
          <Button
            type="primary"
            shape="round"
            disabled={!recordData?.Id}
            onClick={() => hmiOperation('delete', UserId)}
            style={{ marginTop: '10px', marginLeft: '5px' }}
          >
            {translation('Delete')}
          </Button>
          <Button
            type="primary"
            shape="round"
            onClick={onClose}
            style={{ marginTop: '10px', marginLeft: '5px' }}
          >
            {translation('Close')}
          </Button>
        </div>
      </Drawer>
      <StyledTable
        size="small"
        columns={columns}
        dataSource={datasource && Array.isArray(datasource) ? datasource.map((data, index) => ({ ...data, key: index })) : []}
        onRow={(record) => (
          {
            onClick: async () => {
              const svgDimensions = await getSvgDimensions(record.Url);
              hmiRef.current && hmiRef.current.setFieldsValue({
                Name: record.Name,
                Type: record.Type,
                fileList: record.fileList
              });
              hForm.current && hForm.current.setFieldsValue({
                filename: record.FileName,
                background: record.JSON?.background,
                Url: record.JSON?.Url,
                viewbox: record.JSON?.viewbox,
                width: record.JSON?.width,
                height: record.JSON?.height,
                fill: record.JSON?.fill,
                fontWeight: record.JSON?.fontWeight,
                fontFamily: record.JSON?.fontFamily,
                intervalOperation: record.JSON?.intervalOperation,
                intervalOnchange: record.JSON?.intervalOnchange,
                dataSource: record.JSON?.dataSource,
                frequency: record.JSON?.frequency,
                codeType: record.JSON?.codeType,
                groupValue1: record.JSON?.groupValue1,
                groupValue2: record.JSON?.groupValue2,
                warningCondition: record.JSON?.warningCondition,
                selectionType: record.JSON?.selectionType,
                method: record.JSON?.api?.method,
                url: record.JSON?.api?.url,
                payload: JSON.stringify(record.JSON?.api?.payload)
              });
              setDeviceSelectionType(record.JSON?.selectionType);
              setType(record.JSON?.type);
              setVisible(true);
              setRecordData(record);
              setEditObj(record);
              setFormObject(record['JSON']);
              setImageDetails({ FileName: record.FileName, path: '' });
              setImageUrl(record.Url);
              setListType('update');
              setEditEditor({
                ...record.JSON,
                api:record?.JSON?.api});
              setHmiData(record.Type);
              setEnable(true);
              setSvgDimensions(svgDimensions);

              // ✅ Directly use the record to get data
              const api = record?.JSON?.api;
              if (api?.url && api?.method) {
                const siteId = localStorage.get('currentSite');
                const accessToken = localStorage.get('accessToken');
                const hmiMappingObject = {
                  method: api.method,
                  url: `${api.url}?SiteId=${siteId}`,
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  },
                  data: api.payload
                };

                axios(hmiMappingObject)
                  .then((response) => {
                    setDeviceSelectionType(response.data || {});
                  })
                  .catch((error) => {
                    console.error('Device selection API error:', error);
                  });
              }
            }
          })}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  userDetails: state.LayoutReducer.UserDetails,
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(HmiConfiguration);